import { Clock, Target, AlertCircle, CheckCircle2 } from "lucide-react";
import { STATUS_LABEL, SLA_TONE, relTime } from "./util";

export default function SummaryStrip({ ws }) {
  const c = ws.case;
  const sla = ws.sla;
  const status = (c.status || "NEW").toUpperCase();
  const slaTone = SLA_TONE[sla.status] || SLA_TONE.GREEN;
  const awaitingWith =
    status === "AWAITING_QUOTE" ? "Contractor"
    : status === "AWAITING_REVIEW" ? "Reviewer"
    : status === "AWAITING_INFO" ? "Customer"
    : status === "AWAITING_INVOICE" ? "Contractor (invoice)"
    : status === "SCHEDULED" ? "On-site visit"
    : ["NEW", "ASSIGNED"].includes(status) ? "PHS team"
    : ["PAID", "COMPLETED", "CLOSED", "CANCELLED"].includes(status) ? "—"
    : "PHS team";

  const nextAction =
    status === "NEW" ? "Triage & assign"
    : status === "ASSIGNED" ? "Request a quote"
    : status === "AWAITING_QUOTE" ? "Chase contractor"
    : status === "QUOTE_REVIEW" || status === "REVIEWING" ? "Approve or push back"
    : status === "AWAITING_INFO" ? "Follow-up customer"
    : status === "APPROVED" ? "Schedule the visit"
    : status === "SCHEDULED" ? "Confirm attendance"
    : status === "IN_PROGRESS" ? "Confirm completion"
    : status === "AWAITING_REVIEW" ? "Quality check"
    : status === "AWAITING_INVOICE" ? "Request invoice"
    : status === "INVOICED" ? "Mark paid"
    : status === "PAID" ? "Confirm complete"
    : "—";

  return (
    <div className="bg-[#0A2547] text-white/95 border-b border-black/40" data-testid="workspace-summary-strip">
      <div className="px-4 sm:px-6 lg:px-8 py-3 grid grid-cols-2 lg:grid-cols-5 gap-3 lg:gap-6">
        <Cell label="Scope" value={c.type_of_works || c.main_concern || "(no scope set)"} testid="summary-scope"/>
        <Cell
          label="Awaiting with"
          value={awaitingWith}
          icon={<Clock size={13} className="text-[#B88A2A]"/>}
          testid="summary-awaiting"
        />
        <Cell
          label="Next action"
          value={nextAction}
          icon={<Target size={13} className="text-[#0F766E]"/>}
          testid="summary-next"
        />
        <Cell
          label="Status"
          value={STATUS_LABEL[status] || status}
          icon={
            ["COMPLETED", "PAID", "CLOSED"].includes(status)
              ? <CheckCircle2 size={13} className="text-[#064E2E]"/>
              : ["NEW", "ASSIGNED"].includes(status)
              ? <AlertCircle size={13} className="text-[#B88A2A]"/>
              : <Clock size={13} className="text-white/55"/>
          }
          tone={slaTone}
          testid="summary-status"
        />
        <Cell
          label="Last updated"
          value={relTime(c.updated_at || c.created_at)}
          testid="summary-updated"
        />
      </div>
    </div>
  );
}

function Cell({ label, value, icon, testid }) {
  const valStr = typeof value === "string" ? value : undefined;
  return (
    <div className="min-w-0" data-testid={testid}>
      <p className="text-[10px] tracking-[0.22em] uppercase text-white/45">{label}</p>
      <p className="mt-0.5 text-sm font-medium truncate flex items-center gap-1.5" title={valStr}>
        {icon}
        <span className="truncate">{value}</span>
      </p>
    </div>
  );
}
